import React from "react";
import "./MotorOffsetTable.css";
import { EOpticFeature } from "../../../../Model/EOpticFeature";
import { ObjectiveCalibration, FilterCubeCalibration } from "../../../../Model/ImagerCalibration";
import TextBox from "../../../Common/TextBox";
import MtiButton from "../../../Buttons/MtiButton";

type MotorOffsetProps = {
  opticFeature: EOpticFeature;
  motorCalibrations: Array<ObjectiveCalibration | FilterCubeCalibration>;
  onMotorCalibrationUpdated: (motorCalibrations: Array<ObjectiveCalibration | FilterCubeCalibration>) => void;
  selectedIndex: number;
  onSelectedIndexChanged: (selectedIndex: number) => void;
  onMoveToPosition: (position: number) => void;
  onHome: () => void;
};

export default function MotorOffsetTable({
  opticFeature,
  motorCalibrations,
  onMotorCalibrationUpdated,
  selectedIndex,
  onSelectedIndexChanged,
  onMoveToPosition,
  onHome,
}: MotorOffsetProps) {
  const onRowUpdated = (value: number, index: number) => {
    if (opticFeature === EOpticFeature.ObjectiveZoom) {
      let newObjectiveCalibrations = [...motorCalibrations];
      newObjectiveCalibrations[index] = {
        ...newObjectiveCalibrations[index],
        position: value,
      };
      onMotorCalibrationUpdated(newObjectiveCalibrations);
    }
  };

  const tableRows = motorCalibrations.map((motorCalibration, index) => {
    let display = "";
    if (opticFeature === EOpticFeature.FilterCubes) {
      display = (motorCalibration as FilterCubeCalibration).name;
    } else if (opticFeature === EOpticFeature.ObjectiveZoom) {
      display = (motorCalibration as ObjectiveCalibration).value.toFixed(1) + "X";
    }
    return (
      <tr key={"MOTOR-OFFSET-TABLE-ROW-" + index}>
        <td>
          <div className="motor-offset-table-name-column" onClick={() => onSelectedIndexChanged(index)}>
            <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clipPath="url(#clip0)">
                <path
                  d="M7.77051 0.625L19.0469 8.5L7.77051 16.375V0.625Z"
                  fill={selectedIndex === index ? "#E38006" : "#828282"}
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect width="22.5527" height="15.75" fill="white" transform="translate(0.25293 0.625)" />
                </clipPath>
              </defs>
            </svg>
            {display}
          </div>
        </td>
        <td>
          <TextBox
            name={"Position"}
            isInteger={false}
            value={motorCalibration.position}
            readOnly={!(selectedIndex === index)}
            onChange={(value) => onRowUpdated(value as number, index)}
            variant="number"
            decimalPoint={2}
          />
        </td>
      </tr>
    );
  });

  return (
    <div className="motor-offset-table-container">
      <table className="motor-offset-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Position</th>
          </tr>
        </thead>
        <tbody>{tableRows}</tbody>
      </table>
      <div className="motor-offset-table-button-group">
        <MtiButton onClick={() => onMoveToPosition(motorCalibrations[selectedIndex].position)}>Move</MtiButton>
        <MtiButton onClick={() => onHome()}>Home</MtiButton>
      </div>
    </div>
  );
}
